var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListIconDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 5.9987L12.1894 12.2032C12.0825 13.5925 10.924 14.6654 9.53058 14.6654H6.46942C5.07599 14.6654 3.91748 13.5925 3.8106 12.2032L3.33333 5.9987M14 4.66536C12.2681 3.82135 10.2091 3.33203 8 3.33203C5.7909 3.33203 3.73194 3.82135 2 4.66536M6.66667 3.33203V2.66536C6.66667 1.92898 7.26362 1.33203 8 1.33203C8.73638 1.33203 9.33333 1.92898 9.33333 2.66536V3.33203M6.66667 7.33203V11.332M9.33333 7.33203V11.332",
    stroke: "#414651",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIconDelete);
export default __webpack_public_path__ + "static/media/list_icon_delete.079da96b852ec85fd07258a6ec2c85b7.svg";
export { ForwardRef as ReactComponent };